$(function() {
	$(window).scroll(function(event) {
		windowScrollTop = $(window).scrollTop();
		windowScrollLeft = $(window).scrollLeft();
	});
});